import { AmendmentField } from './amendment-field.model';

const EMPTY = JSON.stringify(null);

/**
 * Returns the ids of the fields whose value differs between two versions of a form, sorted
 * and without duplicates, the way the backend stores `changed_field_ids`.
 *
 * A field missing from one version compares as empty, so a row added to a repeatable widget
 * marks only the fields that were actually filled in, and a removed row marks the fields it had.
 */
export function diffAmendmentFieldIds(
  baseline: readonly AmendmentField[],
  current: readonly AmendmentField[],
): string[] {
  const baselineValues = new Map(baseline.map((field) => [field.id, JSON.stringify(field.value)]));
  const currentValues = new Map(current.map((field) => [field.id, JSON.stringify(field.value)]));
  const changed: string[] = [];

  for (const id of new Set([...baselineValues.keys(), ...currentValues.keys()])) {
    if ((baselineValues.get(id) ?? EMPTY) !== (currentValues.get(id) ?? EMPTY)) {
      changed.push(id);
    }
  }

  return changed.sort();
}
